import React, { useState } from 'react';
import { OverlayTrigger, Popover, Card, Badge } from '../ui-kit';
import ScheduleWarning from '../schedule/ScheduleWarning';
import SkillWarnings from '../general/SkillWarnings';
import { isEmpty } from 'lodash';

const popover = props => (
  <Popover id="popover-basic">
    <Popover.Header as="h3">{props.groupName}</Popover.Header>
    <Popover.Body className="p-0">
      {!isEmpty(props.incidents) && props.showIncidents && (
        <Card className="p-0 m-2">
          <Card.Header className="p-1">{I18n.t('activerecord.models.incidents/incident.zero')}</Card.Header>
          <Card.Body className="p-1">
            {Object.values(props.incidents).map(incident => (
              <a
                key={incident.id}
                className="d-block"
                href={`/activity_reports/${incident.id}`}
                target="_blank"
                rel="noreferrer"
              >
                <Badge variant="primary">{incident.body}</Badge>
              </a>
            ))}
          </Card.Body>
        </Card>
      )}
      {props.availabilityRequirementsArray.map(ar => (
        <Card
          key={ar.id}
          className={`p-1 ${props.availabilityRequirementsArray.length > 1 || props.incidents ? 'm-2' : ''}`}
        >
          <ScheduleWarning
            availabilityRequirementState={props.availabilityRequirementState[ar.id]}
            availabilityRequirement={ar}
          />
          <SkillWarnings arState={props.availabilityRequirementState[ar.id]} skills={props.skills} />
        </Card>
      ))}
    </Popover.Body>
  </Popover>
);

const DetailsPopover = props => {
  const [show, setShow] = useState(false);
  return (
    <div onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement="top"
        show={show}
        overlay={popover({
          groupName: props.groupName,
          availabilityRequirementsArray: props.availabilityRequirements,
          availabilityRequirementState: props.availabilityRequirementState,
          skills: props.skills,
          incidents: props.incidents,
          showIncidents: props.showIncidents
        })}
      >
        {props.children}
      </OverlayTrigger>
    </div>
  );
};

export default DetailsPopover;
